<template>
  <div class="gneyai-rive">
    <canvas ref="canvas" :width="size" :height="size" :style="{ width: size + 'px', height: size + 'px' }"></canvas>
  </div>
</template>

<script>
import { Rive } from '@rive-app/webgl2';

// Maps the logical animation state to its .riv asset. Legacy values
// (idle / thinking / rest) are aliased to keep existing call sites working.
const RIVE_FILES = {
  default: "./pi/rive/gney_default.riv",
  hover: "./pi/rive/gney_hover.riv",
  loading: "./pi/rive/gney_loading_.riv",
  done: "./pi/rive/gney_done.riv",
  error: "./pi/rive/gney_error.riv",
  // legacy aliases
  idle: "./pi/rive/gney_default.riv",
  thinking: "./pi/rive/gney_loading_.riv",
  rest: "./pi/rive/gney_default.riv",
};

export default {
  name: "FTSGneyAi",
  props: {
    size: {
      type: Number,
      default: 60,
    },
    type: {
      type: String,
      default: "default",
      validator: (val) => Object.keys(RIVE_FILES).includes(val),
    },
  },
  data() {
    return {
      rive: null,
    };
  },
  watch: {
    type() {
      this.loadRive();
    },
  },
  mounted() {
    this.loadRive();
  },
  beforeDestroy() {
    this.disposeRive();
  },
  methods: {
    loadRive() {
      this.disposeRive();

      const srcFile = RIVE_FILES[this.type] || RIVE_FILES.default;

      this.rive = new Rive({
        src: srcFile,
        canvas: this.$refs.canvas,
        autoplay: true,
        stateMachines: "State Machine 1",
        onLoad: () => {
          if (this.rive) this.rive.resizeDrawingSurfaceToCanvas();
        },
      });
    },
    disposeRive() {
      if (this.rive) {
        try {
          this.rive.cleanup();
        } catch (e) {
          /* noop */
        }
        this.rive = null;
      }
    },
  },
};
</script>

<style scoped>
.gneyai-rive {
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-gney-ai {
  cursor: pointer;
}
</style>
